import {SimpleFacilityModel} from "../../utils/types/facility";

/** Resolves which facility drives workflow loading in StartWorkflowModal. */
export const resolveActiveFacilityId = (
  facilities: ReadonlyArray<SimpleFacilityModel>,
  selectedFacilityId: string | null,
): string | null => {
  if (facilities.length === 1) {
    return facilities[0]?.id ?? null;
  }

  return selectedFacilityId;
};

export const getSingleFacility = (
  facilities: ReadonlyArray<SimpleFacilityModel>,
): SimpleFacilityModel | undefined =>
  facilities.length === 1 ? facilities[0] : undefined;
